import { format } from "date-fns";

export const DATE_ONLY_FORMAT = "yyyy-MM-dd";

export const parseDateOnly = (dateInput: string | Date): Date => {
  if (dateInput instanceof Date) {
    return new Date(format(dateInput, DATE_ONLY_FORMAT) + "T00:00:00");
  }
  const dateOnly = dateInput.split("T")[0];
  return new Date(dateOnly + "T00:00:00");
};
